import { PaginationMeta } from "./Pagination";

export class CourierShuttle {
  id = 0;
  name = "";
  phoneNumber = "";
  hubId = 0;
  hubName = "";
  shuttleId = 0;
  shuttleName = "";
  cityCode = "";
  dataType = "";

  constructor(fields?: Partial<CourierShuttle>) {
    Object.assign(this, fields);
  }
}

export class CourierShuttleListRequest {
  page = 1;
  limit = 10;
  q = "";
  dataType = "";
  hubId = 0;

  constructor(fields?: Partial<CourierShuttleListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    const params = new URLSearchParams();
    params.append("page", this.page.toString());
    params.append("limit", this.limit.toString());
    params.append("hub_id", this.hubId.toString());

    if (this.q) {
      params.append("q", this.q);
    }

    if (this.dataType) {
      params.append("data_type", this.dataType);
    }

    return params.toString();
  }
}

export class CourierShuttleListResponse {
  data: CourierShuttle[] = [];
  meta = new PaginationMeta();

  constructor(fields?: Partial<CourierShuttleListResponse>) {
    Object.assign(this, fields);
  }
}